// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".deutschland-card-points__logo[data-v-6aa9458a]{height:45px!important;margin-top:11px;width:120px!important}.deutschland-card-points .col[data-v-6aa9458a]{line-height:24px}.deutschland-card-points .col-100pct[data-v-6aa9458a]{width:100%}.deutschland-card-points .extra-points[data-v-6aa9458a]{color:#0f9d58}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
